import axios, {AxiosRequestConfig, AxiosResponse} from 'axios'
import {ElLoading, ElMessage} from "element-plus";
import { clearLoginState } from "utils/LogoutUtil";
import { Page } from "@/router/router-enum";
import router from '@/router'

import {specTimeOutCheck} from "@/utils/utils"
import {IBaseRespone} from "types/api";
//import { getCookie, setDotCookie } from "utils/cookieUtils";

let baseUrl = import.meta.env.VITE_APP_BASE_URL as string

const request = axios.create({
  // API 请求的默认前缀
  baseURL: baseUrl,
  // 与产品沟通，修改默认超时时间为10s
  //timeout: 5000,
  timeoutErrorMessage: 'timeout'
})


request.interceptors.request.use((config: any) => {
  return config
}, onError)


request.interceptors.response.use((response: AxiosResponse<any>) => {
  
  // let lastToke = window.localStorage.getItem('loginJwt')
  // let currentToke = getCookie('X-HC-TOKEN')
  // if(currentToke&&(currentToke!==lastToke)){
  //   window.localStorage.setItem('loginJwt',currentToke)
  // }
  return response
}, onError)

function onError(err: any) {
  // console.log(JSON.stringify(err))
  // ElLoading.service().close()
  // console.log(router)
  // router.replace(Page.LOGIN)

  if (err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求失败!';
        break
      case 401:
        clearLoginState()
        router.replace(window.parent != window.self ? Page.SUPPORT_LOGIN : Page.LOGIN)
        break
      case 403:
        err.message = '拒绝访问';
        break
      case 404:
        err.message = '请求出错';
        break
      case 406:
        err.message = '登录已被踢出请重新登录';
        break
      case 408:
        err.message = '请求超时';
        break
      case 500:
        err.message = '服务器错误';
        break
      case 501:
        err.message = '服务未实现';
        break
      case 502:
        err.message = '网络错误';
        break
      case 503:
        err.message = '服务不可用';
        break
      case 504:
        err.message = '网络超时';
        break
      case 505:
        err.message = 'HTTP版本不受支持';
        break
      default:
        err.message = `连接出错(${err.response.status})!`
    }
    // 请求已发出，服务器返回的 http 状态码不是 2xx，例如：400，500
  } else if (specTimeOutCheck(err)) {
    return Promise.reject(err)
  } else if (err.request) {
    // 请求已发出，但没有收到响应，例如：network error
    err.message = '连接服务器失败'
    // 出现超时请求，且超时请求errormessage并不是默认的timeout(说明超时部分有定制)
  } else {
    // 请求被取消或者发送请求时异常，比如header书写错误
    console.info('error', err.message)
  }
  if (err.response.status != 401) {
    ElMessage.error('网络异常,请稍后重试')
  } else { 
    // ElMessage.error('长时间未操作，请重新登录！')
  }

  return Promise.reject(err) // 防止then resolve方法调用不到,导致loading失败需要catch
}

export async function post<T extends IBaseRespone<any>>(url: string, params: any, config?: AxiosRequestConfig): Promise<T> {
  if (config) {
    config.timeoutErrorMessage = 'timeout-special'
  }
  let response = await request.post<T>(url, params, config)
  // console.log(response)
  return response.data
}

export async function get<T extends IBaseRespone<any>>(url: string, config?: AxiosRequestConfig): Promise<T> {
  if (config) {
    config.timeoutErrorMessage = 'timeout-special'
  }
  let response = await request.get<T>(url, config)
  // console.log(response)
  return response.data
}

export default request

